import React, { useState } from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import { showNotification } from "aldoo-ra/Notification"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"

const NewsletterSubscribe = () => {
  const [email, setEmail] = useState("")

  const handleSubmit = (e) => {
    e.preventDefault()
    showNotification({
      message: "You have successfully subscribed to our newsletter!",
      className: "bg-primary text-white",
    })
  }

  return (
    <CMSRender
      contentType="NewsletterSubscribe"
      renderItem={(data) => {
        return (
          <div className="w-full lg:w-[50%] xl:w-[50%] flex flex-col items-center lg:items-start xl:pt-4 xl:pb-[120px]  mx-auto lg:mx-0">
            {/* Title */}
            <Typography 
              variant="h1"
              className="text-text text-center lg:text-left max-w-[660px] mb-4 md:mb-5"
            >
              {data.title}
            </Typography>

            {/* Subtitle */}
            <Typography
              variant="body1" 
              className="text-center lg:text-left mt-0 mb-4 md:mb-5 xl:mb-6"
            >
              {data.subtitle}
            </Typography>

            {/* Subscribe Form - temporarily hidden on client demand */}
            {/* <form onSubmit={handleSubmit}>
              <div className="w-full md:w-[415px] max-w-[450px] xl:w-[532px] xl:h-[68px] flex items-center justify-between bg-gray_100 border border-gray_200 rounded-full px-[6px] lg:px-2 xl:px-3 py-[5px] lg:py-2 xl:py-3">
                <div className="flex-grow flex items-center gap-1 md:gap-3 px-2 md:px-4">
                  <img 
                    className="w-[24px] h-[24px] text-gray_500"
                    src= {data.email_icon}
                  />

                  <Typography component="div" variant="body1">
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder={data.placeholder}
                      required
                      className="w-full bg-transparent outline-none text-gray_900 placeholder-gray_700"
                    />
                  </Typography>
                </div>

                <Button
                  type="submit"
                  variant="primary_s"
                  className="min-w-[130px] whitespace-nowrap"
                >
                  {data.cta}
                </Button>
              </div>
            </form> */}
          </div>
        )
      }}
    />
  )
}

export default NewsletterSubscribe
